module.exports = __webpack_public_path__ + "img/logo_fluxsolar.01c98b4f.png";